module.exports = __webpack_public_path__ + "static/media/file.79b6728c.svg";